"use strict";
// Copyright (C) 2017-2023 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var lodash_throttle_1 = __importDefault(require("lodash.throttle"));
var stremio_router_1 = require("stremio-router");
var common_1 = require("stremio/common");
var components_1 = require("stremio/components");
var constants_1 = require("./constants");
var Menu_1 = __importDefault(require("./Menu"));
var General_1 = __importDefault(require("./General"));
var Player_1 = __importDefault(require("./Player"));
var Streaming_1 = __importDefault(require("./Streaming"));
var Shortcuts_1 = __importDefault(require("./Shortcuts"));
var Info_1 = __importDefault(require("./Info"));
var Settings_less_1 = __importDefault(require("./Settings.less"));
var Settings = function () {
    var routeFocused = (0, stremio_router_1.useRouteFocused)().routeFocused;
    var profile = (0, common_1.useProfile)();
    var platform = (0, common_1.usePlatform)();
    var streamingServer = (0, common_1.useStreamingServer)();
    var sectionsContainerRef = (0, react_1.useRef)(null);
    var generalSectionRef = (0, react_1.useRef)(null);
    var playerSectionRef = (0, react_1.useRef)(null);
    var streamingServerSectionRef = (0, react_1.useRef)(null);
    var shortcutsSectionRef = (0, react_1.useRef)(null);
    var sections = (0, react_1.useMemo)(function () { return ([
        { ref: generalSectionRef, id: constants_1.SECTIONS.GENERAL },
        { ref: playerSectionRef, id: constants_1.SECTIONS.PLAYER },
        { ref: streamingServerSectionRef, id: constants_1.SECTIONS.STREAMING },
        { ref: shortcutsSectionRef, id: constants_1.SECTIONS.SHORTCUTS },
    ]); }, []);
    var _a = (0, react_1.useState)(constants_1.SECTIONS.GENERAL), selectedSectionId = _a[0], setSelectedSectionId = _a[1];
    var updateSelectedSectionId = (0, react_1.useCallback)(function () {
        var container = sectionsContainerRef.current;
        for (var _i = 0, sections_1 = sections; _i < sections_1.length; _i++) {
            var section = sections_1[_i];
            var sectionContainer = section.ref.current;
            if (sectionContainer && (sectionContainer.offsetTop + container.offsetTop) < container.scrollTop + 50) {
                setSelectedSectionId(section.id);
            }
        }
    }, []);
    var onMenuSelect = (0, react_1.useCallback)(function (event) {
        var section = sections.find(function (section) {
            return section.id === event.currentTarget.dataset.section;
        });
        var container = sectionsContainerRef.current;
        section && container.scrollTo({
            top: section.ref.current.offsetTop - container.offsetTop,
            behavior: 'smooth'
        });
    }, []);
    var onContainerScroll = (0, react_1.useCallback)((0, lodash_throttle_1.default)(function () {
        updateSelectedSectionId();
    }, 50), []);
    (0, react_1.useLayoutEffect)(function () {
        if (routeFocused) {
            updateSelectedSectionId();
        }
    }, [routeFocused]);
    return (react_1.default.createElement(components_1.MainNavBars, { className: Settings_less_1.default['settings-container'], route: 'settings' },
        react_1.default.createElement("div", { className: (0, classnames_1.default)(Settings_less_1.default['settings-content'], 'animation-fade-in') },
            react_1.default.createElement(Menu_1.default, { selected: selectedSectionId, streamingServer: streamingServer, onSelect: onMenuSelect }),
            react_1.default.createElement("div", { ref: sectionsContainerRef, className: Settings_less_1.default['sections-container'], onScroll: onContainerScroll },
                react_1.default.createElement(General_1.default, { ref: generalSectionRef, profile: profile }),
                react_1.default.createElement(Player_1.default, { ref: playerSectionRef, profile: profile }),
                react_1.default.createElement(Streaming_1.default, { ref: streamingServerSectionRef, profile: profile, streamingServer: streamingServer }),
                !platform.isMobile && react_1.default.createElement(Shortcuts_1.default, { ref: shortcutsSectionRef }),
                react_1.default.createElement(Info_1.default, { streamingServer: streamingServer })))));
};
var SettingsFallback = function () { return (react_1.default.createElement(components_1.MainNavBars, { className: Settings_less_1.default['settings-container'], route: 'settings' })); };
exports.default = (0, common_1.withCoreSuspender)(Settings, SettingsFallback);
